import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Navbar from './Navbar';
import Home from './Components/Home';
import details from './Components/details';
import ToDos from './Components/ToDos';
import Error from './Components/Error';
import addToDo from './Components/addToDo';
import ToDoLink from './Components/ToDoLink';

import './App.css';

class App extends Component {
  render() {
    return (
        <div className="container-fluid">
          <Navbar />
          <Switch>
            <Route path="/" component={Home} exact />
            <Route path="/todos" component={ToDos} />
            <Route path="/addToDo" component={addToDo} />
            <Route path="/todolink/:todo" component={ToDoLink} />
            <Route path="todo" component={details}/>
            <Route component={Error} />
          </Switch>
        </div>
    );
  }
}

export default App;
